import React from 'react';
import { Factory, NotebookPen } from 'lucide-react';
import { LateBadge } from '../production/LateBadge';

const COLOR = '#064E3B';

const paymentInfo = (status) => {
    if (status === 'saldato') return { label: 'Saldato', color: '#10B981' };
    if (status === 'acconto') return { label: 'Acconto', color: '#F59E0B' };
    return { label: 'Non saldato', color: '#6B7280' };
};

export const WeekProductionColumn = ({ items, oppById, getSellerName, getClientName, weekNotes, openOffer, onRelazione }) => (
    <div className="p-2" data-testid="week-production-column">
        <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider mb-2" style={{ color: '#064E3B' }}>
            <Factory size={14} /> Inizio produzione
        </div>
        {items.length === 0 ? (
            <p className="text-xs text-muted-foreground px-1">Nessun inizio produzione</p>
        ) : (
            <div className="space-y-1">
                {items.map((a) => {
                    const opp = oppById.get(a.opportunity_id) || {};
                    const p = paymentInfo(opp.payment_status);
                    const notes = weekNotes(a, opp);
                    return (
                        <div
                            key={a.id}
                            className="flex flex-wrap items-center gap-x-3 gap-y-0.5 text-sm px-2 py-1 rounded-sm border-l-2 cursor-pointer hover:brightness-95 transition-all"
                            style={{ borderLeftColor: COLOR, backgroundColor: `${COLOR}10` }}
                            onClick={() => openOffer(a.opportunity_id)}
                            title="Apri offerta"
                            data-testid={`week-production-${a.id}`}
                        >
                            <span className="font-medium">{opp.title || a.title}</span>
                            <span className="text-[10px] font-semibold px-1.5 py-0.5 rounded-full text-white" style={{ backgroundColor: p.color }}>{p.label}</span>
                            <LateBadge opp={opp} testId={`week-production-late-${a.id}`} />
                            {opp.commessa && <span className="text-xs text-muted-foreground">Commessa: <b className="text-foreground">{opp.commessa}</b></span>}
                            {opp.telaio && <span className="text-xs text-muted-foreground">Telaio: <b className="text-foreground">{opp.telaio}</b></span>}
                            <span className="text-xs text-muted-foreground">Venditore: <b className="text-foreground">{getSellerName(a.assigned_to) || '—'}</b></span>
                            <span className="text-xs text-muted-foreground">Cliente: <b className="text-foreground">{getClientName(a.client_id) || '—'}</b></span>
                            {notes && (
                                <span className="basis-full text-xs text-muted-foreground italic">Note: <span className="text-foreground not-italic">{notes}</span></span>
                            )}
                            {onRelazione && (
                                <button type="button" onClick={(e) => { e.stopPropagation(); onRelazione(a); }} className="text-xs text-primary hover:underline inline-flex items-center gap-1 print:hidden" data-testid={`week-production-relazione-${a.id}`}>
                                    <NotebookPen size={12} /> Scrivi relazione
                                </button>
                            )}
                        </div>
                    );
                })}
            </div>
        )}
    </div>
);
